<!--<link rel="stylesheet" href="../assets/layout/sass/_login.scss">-->
<template>
    <div :class="containerClass">
        <app-login></app-login>
    </div>
</template>

<script>
    import AppLogin from '../components/Login';

    export default {
        name: "Login",
        computed: {
            containerClass() {
                return ['layout-wrapper', {
                    'layout-dark': this.$store.state.theme === 'dark',
                    'layout-light': this.$store.state.theme === 'light',
                }];
            },
        },
        components: {
            'AppLogin': AppLogin,
        }
    }

</script>

<style lang="scss">
    @import '../App.scss';

</style>